import { render } from "./ImageUpload.vue?vue&type=template&id=2f0335cf"
import script from "./ImageUpload.vue?vue&type=script&lang=js"
export * from "./ImageUpload.vue?vue&type=script&lang=js"

import "../style.scss?vue&type=style&index=0&lang=scss&external"
import "./ImageUpload.vue?vue&type=style&index=1&id=2f0335cf&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__